import React, {Component} from 'react';
import {connect} from 'react-redux';
import {closePopup} from 'helpers/modal';

class CloseWindow extends Component {
    onClick() {
        this.props.dispatch(closePopup());
        this.props.onClick?.();
    }

    render() {
        return <button type="button" onClick={() => this.onClick()} className="close"></button>;
    }
}

export default connect(() => ({}))(CloseWindow);
